import { makeStyles } from "tss-react/mui"
import { Stack, Typography } from "@mui/material"
import { faRepeat } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

import { RepeatOrderFormValues } from "../../../createOrder/components/drawer/meetingDetails/RepeatOrderDialog"
import {
    formatRecurrence,
    formatRepeatSummary,
    getRepeatDeliveryDays,
} from "../../../createOrder/components/drawer/meetingDetails/helpers"
import { RepeatDeliveryDaysList } from "../../../createOrder/components/drawer/meetingDetails/RepeatDeliveryDaysList"
import { useAppLocalization } from "../../../../../modules/localization/components/AppLocalizationProvider"
import { LocalizedStrict } from "../../../../../modules/localization/components/AppLocalized"
import { useDateTime } from "../../../../../modules/localization/useDateTime"

import { AccordionSection } from "./AccordionSection"

const useStyles = makeStyles()((theme) => ({
    icon: {
        color: theme.palette.tailwind.slate[400],
        marginTop: ".25rem",
    },
}))

type RepeatOrderProps = Readonly<{
    repeatDetails: Partial<RepeatOrderFormValues>
}>

export function RepeatOrder({ repeatDetails }: RepeatOrderProps) {
    const { classes } = useStyles()
    const { l10n } = useAppLocalization()
    const dateTimeFactory = useDateTime()

    const days = getRepeatDeliveryDays(repeatDetails)

    return (
        <LocalizedStrict id="confirm-order-dialog-repeat-order" attrs={{ title: true }}>
            <AccordionSection
                title="Repeat order"
                defaultExpanded
                subTitle={
                    <Stack flexDirection="row" gap=".5rem">
                        <FontAwesomeIcon icon={faRepeat} className={classes.icon} />
                        <Typography variant="body1">
                            {days.length > 0
                                ? formatRepeatSummary({ values: repeatDetails, days, l10n, dateTimeFactory })
                                : formatRecurrence({ values: repeatDetails, l10n })}
                        </Typography>
                    </Stack>
                }
            >
                <RepeatDeliveryDaysList days={days} />
            </AccordionSection>
        </LocalizedStrict>
    )
}
